export default __webpack_public_path__ + "019c0ada9ecb566c8385ebdfba4756e1.png";